import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "option-header" }
const _hoisted_2 = {
  key: 0,
  class: "payment-amounts"
}
const _hoisted_3 = { class: "payment in-school" }
const _hoisted_4 = { class: "payment post-school" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }

import { computed, ref, watch, onMounted } from "vue";
import BaseFormField from "@/components/shared/BaseFormField.vue";
import { useStore } from "vuex";
import type { RatePlanRepaymentVM, RatePlanVM } from "@/models/loanConfiguration";
import type { FormSchema } from "@/models/form";


export default /*@__PURE__*/_defineComponent({
  __name: 'RepaymentOption',
  props: {
    ratePlan: {},
    option: {},
    schoolSelected: { type: Boolean },
    requestedAmount: {}
  },
  emits: ["update:model-value"],
  setup(__props: any, { emit: __emit }) {

const fieldRef = ref<InstanceType<typeof BaseFormField>>();

const store = useStore();

const props = __props;

const emit = __emit;

const loanConfigurationModule = computed(() => store.state.loanConfigurationModule);

const isSelected = computed<boolean>(() => {
  return (
    loanConfigurationModule.value?.selectedRatePlan?.id === props.ratePlan?.id &&
    loanConfigurationModule.value?.selectedRepaymentOption?.repaymentTypeId ===
      props.option?.repaymentTypeId
  );
});

const selectedPaymentOption = ref<number>(0);

const schema = ref<FormSchema>({
  paymentOption: {
    name: "paymentOption",
    type: "radio",
    required: true,
    hideLabel: true,
  },
});

watch(
  () => loanConfigurationModule.value.selectedRepaymentOption?.repaymentTypeId,
  () => {
    selectedPaymentOption.value = loanConfigurationModule.value.selectedRepaymentOption;
  },
);

onMounted(() => {
  if (
    fieldRef.value &&
    fieldRef.value.radioInput &&
    (fieldRef.value.radioInput[0] as HTMLInputElement) &&
    isSelected.value
  ) {
    (fieldRef.value.radioInput[0] as HTMLInputElement).click();
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["payment-option", { active: isSelected.value }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(BaseFormField, {
        ref_key: "fieldRef",
        ref: fieldRef,
        modelValue: selectedPaymentOption.value,
        "onUpdate:modelValue": [
          _cache[0] || (_cache[0] = ($event: any) => ((selectedPaymentOption).value = $event)),
          _cache[1] || (_cache[1] = ($event: any) => (emit('update:model-value', $event)))
        ],
        schema: schema.value.paymentOption,
        options: [__props.option]
      }, null, 8, ["modelValue", "schema", "options"]),
      _createElementVNode("h3", null, _toDisplayString(__props.option.repaymentTypeName), 1)
    ]),
    (__props.schoolSelected && __props.requestedAmount && __props.requestedAmount > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("p", null, _toDisplayString(__props.option.monthlyInSchoolPaymentDisplay), 1),
            _cache[2] || (_cache[2] = _createElementVNode("p", null, "In-School Monthly Payments", -1))
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("p", null, _toDisplayString(__props.option.monthlyPostSchoolPaymentDisplay), 1),
            _cache[3] || (_cache[3] = _createElementVNode("p", null, "Post Graduation Monthly Payments", -1))
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (
          (!__props.schoolSelected && __props.requestedAmount && __props.requestedAmount === 0) ||
          (!__props.schoolSelected && !__props.requestedAmount)
        )
            ? (_openBlock(), _createElementBlock("p", _hoisted_6, " To see your estimated payments, please select a school and an initial request for funds. If you are unsure, you do not need to update your school or request an amount, but you will not see estimated payment amounts. "))
            : (_openBlock(), _createElementBlock("p", _hoisted_7, " To see your estimated payments, please select an initial request for funds. If you are unsure, you do not need to request an amount, but you will not see estimated payment amounts. "))
        ]))
  ], 2))
}
}

})